import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AlertComponent } from './alerts/alert.component';
import { SharedModule } from '../shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { ClientcasesComponent } from './clientcases/clientcases.component';
import { SwitchOfficeContainer } from './switchoffice/switchoffice.container';
import { SwitchOfficeComponent } from './switchoffice/switchoffice.component';
import { ImpersonateContainer } from 'app/admin/impersonate/impersonate.container';
import { ImpersonateComponent } from 'app/admin/impersonate/impersonate.component';
import { SkillebladeModalComponent } from './skilleblade-modal/skilleblade-modal.component';
import { SkillebladeModalContainer } from './skilleblade-modal/skilleblade-modal.container';
import { OpdateringNoterComponent } from './opdatering-noter/opdatering-noter.component';
import { SafeHtmlPipe } from './safe-html.pipe';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule
    ],
    exports: [
        AlertComponent,
        SidebarComponent,
        HeaderComponent,
        SwitchOfficeContainer,
        ClientcasesComponent,
    ],
    declarations: [
        AlertComponent,
        SidebarComponent,
        HeaderComponent,
        ClientcasesComponent,
        SwitchOfficeContainer,
        SwitchOfficeComponent,
        ImpersonateContainer,
        ImpersonateComponent,
        SkillebladeModalComponent,
        SkillebladeModalContainer,
        OpdateringNoterComponent,
        SafeHtmlPipe
    ]
})

export class CoreModule { }
